import { autoinject } from "aurelia-dependency-injection";
import { RequestClientService } from "@rightship-tech/common-ui/services/basic/request-client.service";
import { CleanCustomerVesselResponse, GetCustomerSubscriptionResponse, SaveCustomerSubscriptionRequest } from "../../models/customers/customer-subscription.models";
import { GetBuRuleCollectionModel } from "../../models/rules/rules.models";
import {Urls} from "../../constants/modules/customer-subscription.constants";

@autoinject()
export class CustomerSubscriptionService {

    getCustomerSubscriptionPromiseCache: { [productCode: string]: Promise<GetCustomerSubscriptionResponse> } = {};

    constructor(private requestClient: RequestClientService) { }

    async getMySubscription(productCode: string, reload: boolean = false): Promise<GetCustomerSubscriptionResponse> {
        if (this.getCustomerSubscriptionPromiseCache[productCode] && !reload) {
            return await this.getCustomerSubscriptionPromiseCache[productCode];
        }

        this.getCustomerSubscriptionPromiseCache[productCode] = this.requestClient.get<GetCustomerSubscriptionResponse>(Urls.GetMySubscription, { productCode });

        return await this.getCustomerSubscriptionPromiseCache[productCode];
    }

    public getCustomerSubscription(customerId: number, productCode: string): Promise<GetCustomerSubscriptionResponse> {
        return this.requestClient.post<GetCustomerSubscriptionResponse>(`${Urls.GetCustomerSubscription}`, {}, { customerId, productCode });
    }

    public getRuleCollection(customerId: number): Promise<GetBuRuleCollectionModel[]> {
        return this.requestClient.get<GetBuRuleCollectionModel[]>(`${Urls.GetRuleCollection}/${customerId}`);
    }

    public createOrUpdateCustomerSubscription(request: SaveCustomerSubscriptionRequest): Promise<GetCustomerSubscriptionResponse> {
        return this.requestClient.post<GetCustomerSubscriptionResponse>(`${Urls.CreateOrUpdateCustomerSubscription}`, {}, request);
    }

    public cleanCustomerVessels(customerId: number): Promise<CleanCustomerVesselResponse> {
        return this.requestClient.post<CleanCustomerVesselResponse>(`${Urls.CleanCustomerVessels}`, {}, { customerId: customerId});
    }
}